'use client';

import { HeartFilledColoredIcon, HeartFilledIcon } from '@repo/icons';
import { SideMenuItem } from '@repo/ui/side-menu-item';
import { useTranslations } from 'next-intl';
import { renderIcon } from '@/components/layout/sidebar-left/render-icon';
import useFavoritesGameClick from '@/hooks/useFavoritesGameClick';
import { usePathname, useRouter } from '@/i18n/routing';
import { useTenant } from '@/providers/TenantProvider';

type FavoritesProps = {
  sidebarOpen: boolean;
};

const Favorites = ({ sidebarOpen }: FavoritesProps) => {
  const t = useTranslations('sidebar-left');
  const router = useRouter();
  const pathname = usePathname();

  const { tenantMachineName } = useTenant();

  const isActive = pathname.includes('/casino/favorites');

  const { favoriteCasinoGameIds } = useFavoritesGameClick();

  return (
    <SideMenuItem
      isActive={isActive}
      text={sidebarOpen && t('favorites')}
      Icon={renderIcon(HeartFilledIcon, HeartFilledColoredIcon, tenantMachineName)}
      optionalLastElement={sidebarOpen && <span>{favoriteCasinoGameIds?.length || 0}</span>}
      onClick={() => router.push('/casino/favorites')}
      tooltipText={t('favorites')}
      showTooltip={!sidebarOpen}
    />
  );
};

export default Favorites;
